"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectorPipe = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _models = require("../../models");
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
var _Types = require("../../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConnectorPipe = props => {
  const {
    index,
    pipesLength,
    pipeIndex,
    connectWithPrevious = false,
    pipe = {
      highlightsType: '',
      display: true
    },
    connectTo = _constants.ConnectTo.null,
    startConnectByPipe = [_constants.ConnectTo.null, _constants.ConnectTo.null],
    isLast = false
  } = props;
  const isSecondConnect = index === 1;
  const getPositionOnPipe = function getPositionOnPipe() {
    let i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return (
      /** position centering by function: i * s/n + s/2n
       * , where i - index, s - pipe length, n - count of pipes */
      i * _constants.ModelWidth.connector / pipesLength + _constants.ModelWidth.connector / (2 * pipesLength)
    );
  };
  const positionOnPipe = getPositionOnPipe(pipeIndex) - _constants.ModelWidth.connector;
  const isDefaultStartConnect = !startConnectByPipe[pipeIndex] || startConnectByPipe[pipeIndex] === _constants.ConnectTo.null;
  const mainPipePositionZ = () => {
    if (index !== 0 || isDefaultStartConnect) return 0;
    if (startConnectByPipe[pipeIndex] === _constants.ConnectTo.left) return positionOnPipe + _constants.sizeOfCurvePipePerUnit;
    return positionOnPipe - _constants.sizeOfCurvePipePerUnit;
  };
  const mainPipeScaleZ = () => {
    if (index !== 0 || isDefaultStartConnect) return _constants.sizeOfStraightPipePerUnit * (_constants.ModelWidth.connector - _constants.connectCubeWidth);
    if (startConnectByPipe[pipeIndex] === _constants.ConnectTo.left) return _constants.sizeOfStraightPipePerUnit * positionOnPipe;
    return _constants.sizeOfStraightPipePerUnit * (_constants.ModelWidth.connector - _constants.connectCubeWidth + positionOnPipe - _constants.sizeOfCurvePipePerUnit);
  };
  const mainConnectCurveRotateY = () => {
    if (startConnectByPipe[pipeIndex] === _constants.ConnectTo.left) return 0;
    return -Math.PI / 2;
  };
  const mainConnectCurvePosition = () => {
    if (startConnectByPipe[pipeIndex] === _constants.ConnectTo.left) return [0, 0, positionOnPipe + 1];
    return [-1, 0, positionOnPipe];
  };
  const connectRowsPipeScaleZ = () => {
    const customUnit = 0.2;
    const scaleUnit = (isSecondConnect && !(isLast && connectTo === _constants.ConnectTo.null) ? _constants.sizeOfStraightPipePerUnit : customUnit).toFixed(3);
    const negativeScaleWhenCurve = isSecondConnect && !isDefaultStartConnect ? _constants.sizeOfCurvePipePerUnit : 0;
    return (_constants.spaseBetweenModelsByCol - negativeScaleWhenCurve) * scaleUnit;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("group", {
    visible: connectWithPrevious
  }, /*#__PURE__*/_react.default.createElement("group", {
    position: [0, (pipeIndex + 1) * _constants.verticalPipeSpacing, positionOnPipe]
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [isLast && connectTo === _constants.ConnectTo.null ? 0 : 1.1, 0, 0],
    scale: [1, 1, connectRowsPipeScaleZ()],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: pipe.highlightsType
  }), connectTo === _constants.ConnectTo.right ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 0, -1],
    rotation: [0, -Math.PI, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, -1],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (_constants.ModelWidth.connector + positionOnPipe - 1 - _constants.connectCubeWidth)],
    rotation: [0, 0, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, -(_constants.ModelWidth.connector + positionOnPipe - _constants.connectCubeWidth)],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: pipe.highlightsType
  })) : null, connectTo === _constants.ConnectTo.left ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 0, 1],
    rotation: [Math.PI, Math.PI, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, 1],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (positionOnPipe + 2 * _constants.connectCubeWidth)],
    rotation: [0, 0, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, -positionOnPipe],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: pipe.highlightsType
  })) : null, /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 0],
    visible: connectTo === _constants.ConnectTo.skipHorizontal
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, 0],
    scale: [1, 1, 0.22],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: pipe.highlightsType
  })))), /*#__PURE__*/_react.default.createElement("group", {
    visible: connectTo === _constants.ConnectTo.null || !connectWithPrevious,
    position: [0, (pipeIndex + 1) * 10, 0]
  }, isDefaultStartConnect || startConnectByPipe[pipeIndex] === _constants.ConnectTo.left || index !== 0 ? /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, 0],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: pipe.highlightsType
  }) : null, index === 0 && !isDefaultStartConnect ? /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: mainConnectCurvePosition(),
    rotation: [0, mainConnectCurveRotateY(), 0],
    highlightsType: pipe.highlightsType
  }) : null, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, mainPipePositionZ()],
    scale: [1, 1, mainPipeScaleZ()],
    rotation: [0, 0, 0],
    highlightsType: pipe.highlightsType
  }), isDefaultStartConnect || startConnectByPipe[pipeIndex] === _constants.ConnectTo.right || index === 0 ? /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, -_constants.ModelWidth.connector + _constants.connectCubeWidth],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: pipe.highlightsType
  }) : null));
};
exports.ConnectorPipe = ConnectorPipe;
ConnectorPipe.propTypes = {
  pipeIndex: _propTypes.default.number.isRequired,
  connectWithPrevious: _propTypes.default.bool,
  pipe: _Types.ConnectPipeType.isRequired,
  connectTo: _propTypes.default.oneOf(Object.values(_constants.ConnectTo)),
  startConnectByPipe: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.values(_constants.ConnectTo))),
  isLast: _propTypes.default.bool,
  pipesLength: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired
};
ConnectorPipe.defaultProps = {
  connectWithPrevious: false,
  connectTo: _constants.ConnectTo.null,
  startConnectByPipe: [],
  isLast: false
};